export const api = {
  queryLiftList: "/bas/firefightoperation/queryBacnetStatusList.json", //查询电梯
};
